import DatePicker from '@cnamts/vue-dot/src/patterns/DatePicker'

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(DatePicker,_vm._b({attrs:{"value":_vm.field.value,"vuetify-options":_vm.field.fieldOptions,"text-field-class":"vd-form-input"},on:{"change":_vm.emitChangeEvent}},'DatePicker',_vm.field.fieldOptions,false))
}
var staticRenderFns = []

export { render, staticRenderFns }